import {listStyles} from "@insite/content-library/Widgets/ProductList/ProductListCardList";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

listStyles.wrapper = {
    css: css`
        margin-top: 0;
    `,
};

listStyles.cardList = {
    gridContainer: {
        gap: 0,
        css: css``,
        offsetProps: { style: { width: "100%" } },
    },
};

listStyles.cardContainerStyles = {
    gridItem: {
        css: css`
            border-bottom: none;
        `,
    },
    cardDivider: {
        css: css`
            width: 100%;
            border-top: 1px solid ${getColor("common.border")};
            &:last-child {
                border-bottom: none;
            }
        `,
    },
};

listStyles.cardContainerMultiColumnStyles = {
    cardDivider: {
        css: css`
            padding: 15px 25px;
            height: 100%;
            width: 100%;
            overflow: hidden;
            max-width: 450px;
        `,
    },
    gridItem: {
        css: css`
            border-bottom: none;
        `,
    },
};
